import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P7-E1",
    audio: "",
    video: "",
    component: UI,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page7/E1/1.jpg" }]],
  },
  2: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P7-E2",
    audio: "img/FriendsPlus/Page7/Audio/audio-e2-p7.mp3",
    video: "",
    component: UI,
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page7/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page7/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page7/Audio/tieude-e2-p7.mp3",
        },
        { url: "img/FriendsPlus/Page7/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page7/E2/4.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P7-E3",
    audio: "",
    video: "",
    component: D1,
    exerciseKey: "img/FriendsPlus/Page7/E3/Key/answerKey.png",
    textAlign: 'center',
    maxLength: 1,
    fontSize: 27,
    // inputHeight: '100%',
    isAllowSubmit: true,
    // isLargeInput: true,
    questionImage: [
      [{ url: "img/FriendsPlus/Page7/E3/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page7/E3/2.jpg" },
        { url: "img/FriendsPlus/Page7/E3/3.jpg", input: true, answer: "3" },
        { url: "img/FriendsPlus/Page7/E3/4.jpg" },
        { url: "img/FriendsPlus/Page7/E3/5.jpg", input: true, answer: "7" },
        { url: "img/FriendsPlus/Page7/E3/6.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page7/E3/7.jpg" },
        { url: "img/FriendsPlus/Page7/E3/8.jpg", input: true, answer: "5" },
        { url: "img/FriendsPlus/Page7/E3/9.jpg" },
        { url: "img/FriendsPlus/Page7/E3/10.jpg", input: true, answer: "4" },
        { url: "img/FriendsPlus/Page7/E3/11.jpg" },
        { url: "img/FriendsPlus/Page7/E3/12.jpg", input: true, answer: "1" },
        { url: "img/FriendsPlus/Page7/E3/13.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page7/E3/14.jpg" },
        { url: "img/FriendsPlus/Page7/E3/15.jpg", input: true, answer: "2" },
        { url: "img/FriendsPlus/Page7/E3/16.jpg" },
        { url: "img/FriendsPlus/Page7/E3/17.jpg", input: true, answer: "6" },
        { url: "img/FriendsPlus/Page7/E3/18.jpg" },
        { url: "img/FriendsPlus/Page7/E3/19.jpg", input: true, answer: "8" },
        { url: "img/FriendsPlus/Page7/E3/20.jpg" },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page7/E3/21.jpg" },
        { url: "img/FriendsPlus/Page7/E3/22.jpg", input: true, answer: "9" },
        { url: "img/FriendsPlus/Page7/E3/23.jpg" },
      ],
    ],
  },
};

export default json;
